// extracted by mini-css-extract-plugin
export default {"sectionLocations":"_1tKj4","sectionLocationsTitle":"_15am-","currentLocationIcon":"_3Aljz","currentLocation":"f6e0w"};